module.exports = __webpack_public_path__ + "img/d200902-1.5d72294c.jpg";